<script>
    import { Router, Link, Route, navigate } from "svelte-routing";
    import Home from "./routes/Home.svelte";
    import { setupI18n, _ } from './lib/i18n';

    import { onMount, onDestroy } from 'svelte';
    import DefaultLayout from "./layouts/DefaultLayout.svelte";
    import Login from "./routes/Login.svelte";
    import Signup from "./routes/Signup.svelte";
    import AddAccount from "./routes/AddAccount.svelte";
    import Subscription from "./routes/Subscription.svelte";
    import Order from "./routes/Order.svelte";
    import Tutorial from "./routes/Tutorial.svelte";
    import NotificationSettings from "./routes/NotificationSettings.svelte";
    import Settings from "./routes/Settings.svelte";
    import OrderSuccess from "./routes/OrderSuccess.svelte";
    import Analyze from "./routes/Analyze.svelte";
    import {loadMoreComments, loadMoreFollows, loadMoreFollowers, loadMoreStories, loadMorePosts, createAnalyze, forceFeedUpdate, restartAnalyze, updateAnalyzeResult} from "./lib/ApiRequests.svelte";
    import {initClient} from "./lib/Centrifuge.svelte";
    import {calcTimeByOffset, dateToSqlFormat, parseDateFromString} from "./lib/Common.svelte";


    export let language = 'ru-RU';

    setupI18n({ withLocale: language });
    export let domain = 'instashpion.ru';
    export let currentUrl = '';
    export let isGuest = true;
    export let site = null;
    export let date = null;

    export let path = '';

    export let analyzes = [];

    export let availableTariffs = [];

    export let unsubscribeDiscountValue = 0;
    export let unsubscribeDiscountedPrice = 0;

    export let centrifugeSettings = {
        url: null,
        user: null,
        timestamp: null,
        token: null,
        authEndpoint: null,
    }

    let centrifuge;


    let startedAnalyzes = 0;
    function countStartedAnalyzes() {
        let count = 0;
        for (let i in analyzes) {
            if (analyzes[i].temporary === true) continue;
            count++;
        }

        startedAnalyzes = count;
    }

    $: analyzes && countStartedAnalyzes();

    export let identity = {};

    function onNavigateToEvent(event) {
        navigate(event.detail.name);
    }

    function forceAnalyzeRefresh(analyze) {
        document.dispatchEvent(new CustomEvent('refreshAnalyze', { 'detail': analyze }));
    }

    function onIncorrectPassword(data) {
        console.log('Incorrect password');
        console.log(data);
        for (let i = 0; i < analyzes.length; i++) {
            const analyze = analyzes[i];
            if (!analyze.handler || Number(analyze.handler.id) !== Number(data.account_id)) continue;

            analyze.is_not_friend = false;
            analyze.isPasswordError = true;
            analyzes = analyzes;
            forceAnalyzeRefresh(getAnalyze(analyze.id));
        }
    }
    function onCheckpoint(data) {
        console.log('Checkpoint');
        console.log(data);

        let channelCaption;
        let maybeCaption;

        if (data.choice === 0) {
            channelCaption = (language === 'ru-RU') ? 'телефон' : 'phone';
            maybeCaption = 'email';

        } else {
            channelCaption = (language === 'ru-RU') ? 'email' : 'email';
            maybeCaption = (language === 'ru-RU') ? 'телефон' : 'phone';
        }

        for (let i = 0; i < analyzes.length; i++) {
            const analyze = analyzes[i];
            if (!analyze.handler || Number(analyze.handler.id) !== Number(data.account_id)) continue;

            analyze.checkpoint = data;

            analyzes = analyzes;
            forceAnalyzeRefresh(getAnalyze(analyze.id));
        }
    }
    function onTwoFactor(data) {
        console.log('Two factor authentication required');
        console.log(data);
    }
    function onSuccessStart(data) {
        console.log('Analyze successfully started');
        console.log(data);
    }
    function onNotFriend(data) {
        console.log('Private account but handler is not a follower');
        console.log(data);
        const analyzeId = data.analyze_id;
        const index = analyzes.findIndex(item => item.id == analyzeId);
        const analyze = analyzes[index];
        analyzes[index].is_not_friend = true;
        analyzes = analyzes;
        forceAnalyzeRefresh(getAnalyze(analyze.id));
    }
    function initCentrifugeClient() {
        centrifuge = initClient(centrifugeSettings, onIncorrectPassword, onCheckpoint, onTwoFactor, onSuccessStart, onNotFriend);
    }

    onMount(() => {
        document.addEventListener('navigateTo', onNavigateToEvent, {
            capture: true
        });
        initCentrifugeClient();
    });

    onDestroy(() => {
        document.removeEventListener('navigateTo', onNavigateToEvent, {
            capture: true
        });
    });

    let identityWithFunctions = identity;
    identity.showAnalyzesLimitWarning = false;
    identity.isActiveSubscription = function () {
        const paidTill = new Date(this.spy_paid_till * 1000);
        const subscriptionStatus = (this.spy_subscription && this.spy_subscription.status) ? this.spy_subscription.status : null;
        const forceEnableOptions = this.spy_full_access_wo_subscription;

        if (paidTill > (new Date()) /*&& forceEnableOptions === true*/) {
            return true;
        }

        if (this.spy_has_single_analyzes) {
            return true;
        }

        if (paidTill > (new Date()) && [1, 3].includes(Number(subscriptionStatus))) {
            return true;
        }

        return false;
    }
    identity.isActiveFreeAccessTrial = function () {
        const paidTill = new Date(this.spy_paid_till * 1000);
        return this.spy_enabled_free_trial && paidTill > (new Date());
    }
    identity.isEnabledFreeTrial = function () {
        return !this.spy_subscription && this.spy_enabled_free_trial;
    }
    identity.changeKeyValue = function (key, value) {
        this[key] = value;
        identity = this;
    }
    identity.addDiscount = function (params = {}) {
        console.log(params);
        this.changeKeyValue('discount', params);
    }
    const initSelectedTariff = () => {
        switch (localStorage.getItem('ru_spy_tariff_selected')) {
            case '1_week':
                return 7;
            case '1_month':
                return 30;
            default:
                return null;
        }
    }

    let dashboardState = {
        language: language,
        pageTitle: null,
        pageTitleTag: $_('main.pageTitleTag'),
        pageMetaDescription: $_('main.pageMetaDescription'),
        pageLinkCanonical: $_('main.pageLinkCanonical'),
        pageId: null,
        availableTariffs,
        isGuest,
        site,
        path,
        lastAccount: null,
        lastRoute: null,
        identity: identityWithFunctions,
        setState: setState,
        addAnalyze: addAnalyze,
        removeAnalyze: removeAnalyze,
        disableAdditionalTrial: disableAdditionalTrial,
        disableSpyWeekDiscount: disableSpyWeekDiscount,
        changeSpySubscriptionStatus: changeSpySubscriptionStatus,
        changeTemporaryEmail: changeTemporaryEmail,
        setPasswordAsTemporary: setPasswordAsTemporary,
        changeTemporaryPassword: changeTemporaryPassword,
        loadMoreComments: loadMoreAnalyzeComments,
        loadMoreFollows: loadMoreAnalyzeFollows,
        loadMoreFollowers: loadMoreAnalyzeFollowers,
        loadMoreStories: loadMoreAnalyzeStories,
        loadMorePosts: loadMoreAnalyzePosts,
        createAnalyze: createAnalyzeAndUpdateArray,
        updateAnalyzeProgress: updateAnalyzeProgress,
        initTariff: initSelectedTariff()
    };

    function updateWindowState() {
        window.shared.state = dashboardState;
        window.shared.analyzes = analyzes;
    }

    $: state = window.shared;
    window.shared.updateState = function () {
        dashboardState = dashboardState;
        updateWindowState();
    }


    function getAnalyze(id) {
        const index = analyzes.findIndex(item => item.id == id);
        const analyze = analyzes[index];

        if (!analyze) {
            navigate(`${path}/dashboard/add-account`);
            return;
        }

        analyze.isError = function () {
            return (this.is_private && (!this.handler || this.is_not_friend)) ||
                this.needRestart ||
                analyze.isPasswordError
            ;
        }
        analyze.checkIsFinished = function () {
            return Number(this.status) === 5 && this.likesProgress === 100;
        }
        analyze.restart = async function () {
            if (this.temporary) return false;

            try {
                const response = await restartAnalyze(this.id);
                if (response.status === 'ok') {
                    this.needRestart = false;
                    return true;
                }
            } catch (err) {
                console.error(err);
                return false;
            }
        }
        analyze.forceFeedUpdate = async function() {
            const response = await forceFeedUpdate(this.id);
            if (response.status === 'ok') {
                //this.feedsLastUpdate = Math.round((new Date()).getTime()/1000);
                //this.last_revision_epoch = Math.round((new Date()).getTime()/1000);
                this.feedsLastUpdate = response.data.feedsLastUpdate;
                this.feedsLastUpdateDate = response.data.feedsLastUpdateDate;
                this.last_revision_epoch = this.feedsLastUpdate;


                return true;
            } else {
                switch (response.data.result) {
                    case 'no_subscribe':
                        navigate(`${dashboardState.path}/dashboard/subscription`);
                        break;
                    case 'private_without_handler':
                        this.is_private = true;
                        this.handler = null;
                        break;
                }
            }

            return false;
        }
        analyze.removeHandler = async function() {
            this.handler = null;
        }
        analyze.unsetIsNotFriend = async function() {
            this.is_not_friend = false;
        }
        analyze.changeHandlerPassword = async function() {

        }
        analyze.changeKeyValue = async function(key, value) {
            this[key] = value;
        }
        analyze.setResults = async function(category, items) {
            await setResults(this.id, category, items);
        }
        analyze.updateResult = updateResult;

        return analyze;
    }

    function getNextId(id) {
        if (analyzes.length === 0) return;
        const index = analyzes.findIndex(item => item.id == id);

        if (analyzes.length - 1 === index) {
            return analyzes[0].id;
        }

        return analyzes[index + 1].id;
    }

    function getPrevId(id) {
        if (analyzes.length === 0) return;
        const index = analyzes.findIndex(item => item.id == id);

        if (index === 0) {
            return analyzes[analyzes.length - 1].id;
        }

        return analyzes[index - 1].id;
    }

    function setState(newParams) {
        let newState = dashboardState;
        for (let key in newParams) {
            if (typeof newParams[key] === 'object' && newParams[key] !== null) {
                for (let subKey in newParams[key]) {
                    newState[key][subKey] = newParams[key][subKey];
                }
            } else {
                newState[key] = newParams[key];
            }
        }

        dashboardState = newState;
        updateWindowState();
    }

    function disableSpyWeekDiscount() {
        try {
            identity.spy_week_discount_available = false;
        } catch (err) { console.error(err) }
        identity = identity;
    }

    function disableAdditionalTrial(newPaidTill) {
        try {
            identity.additional_spy_trial_available = false;
            identity.spy_paid_till = newPaidTill;
        } catch (err) { console.error(err) }
        identity = identity;
    }

    function changeSpySubscriptionStatus(newStatus) {
        if (!identity || !identity.spy_subscription) return false;

        identity.spy_subscription.status = newStatus;
        identity = identity;
        dashboardState = dashboardState;
    }

    function changeTemporaryEmail(newEmail) {
        identity.email = newEmail;
        identity.is_temporary_email = false;
        identity = identity;
    }

    function setPasswordAsTemporary() {
        identity.is_temporary_password = true;
        identity = identity;
    }

    function changeTemporaryPassword() {
        const tmpIdentity = identity;
        tmpIdentity.is_temporary_password = false;
        setState({identity: tmpIdentity});
        //identity = identity;
    }

    function addAnalyze(temporary, analyzeId, instagramId, username, name = null, photo = null, mediaCount = 0, followersCount = 0, followsCount = 0) {
        analyzes.push({
            id: analyzeId,
            temporary: temporary,
            account: {
                instagram_id: instagramId,
                username: username,
                name: name,
                photo: photo,
                media_count: mediaCount,
                followers_count: followersCount,
                follows_count: followsCount,
            }
        });

        analyzes = analyzes;
    }

    function removeAnalyze(id) {
        const index = analyzes.findIndex(item => item.id === id);
        analyzes.splice(index, 1);
        analyzes = analyzes;
    }

    async function loadMoreAnalyzeComments(id, limit = 10, offset = 10) {
        const response = await loadMoreComments(id, limit, offset, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            analyzes[analyzeIndex].result.comments = analyzes[analyzeIndex].result.comments.concat(response.data);
            analyzes = analyzes;

            return response.data;
        }

        return [];
    }

    async function loadMoreAnalyzeFollows(id, limit = 10, offset = 10) {
        const response = await loadMoreFollows(id, limit, offset, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            if (response.data.length !== 0) {
                analyzes[analyzeIndex].result.follows = analyzes[analyzeIndex].result.follows.concat(response.data);
                analyzes = analyzes;
            }

            return response.data;
        }

        return [];
    }

    async function loadMoreAnalyzeFollowers(id, limit = 10, offset = 10) {
        const response = await loadMoreFollowers(id, limit, offset, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            if (response.data.length !== 0) {
                analyzes[analyzeIndex].result.followers = analyzes[analyzeIndex].result.followers.concat(response.data);
                analyzes = analyzes;
            }

            return response.data;
        }

        return [];
    }

    async function loadMoreAnalyzeStories(id, limit = 12, offset = 12) {
        const response = await loadMoreStories(id, limit, offset, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            if (response.data.length !== 0) {
                analyzes[analyzeIndex].result.stories = analyzes[analyzeIndex].result.stories.concat(response.data);
                analyzes = analyzes;
            }

            return response.data;
        }

        return [];
    }

    async function setResults(id, category, items) {
        try {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            analyzes[analyzeIndex].result[category] = items;
            analyzes = analyzes;
        } catch (err) {
            console.error(err);
        }
    }
    async function loadMoreAnalyzePosts(id, limit = 12, offset = 12) {
        const response = await loadMorePosts(id, limit, offset, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id === id);
            analyzes[analyzeIndex].events = analyzes[analyzeIndex].events.concat(response.data);
            analyzes = analyzes;

            return response.data;
        }

        return [];
    }

    async function createAnalyzeAndUpdateArray(username, autostart = 1, type = 0) {
        const response = await createAnalyze(username, autostart, type);
        if (response.status === 'ok') {
            try {
                const tempAnalyzeIndex = analyzes.findIndex(item => item.id == username);
                const analyzeData = response.data;
                //analyzeData.feedsLastUpdate = Math.round(calcTimeByOffset(3).getTime() / 1000); //Math.round((new Date(new Date().toLocaleString('en', {timeZone: 'Europe/Moscow'}))).getTime() / 1000);
                //analyzeData.feedsLastUpdateDate = dateToSqlFormat(calcTimeByOffset(3));
                //analyzeData.feedsLastUpdate = Math.round(parseDateFromString(analyzeData.date_start).getTime() / 1000);
                //analyzeData.feedsLastUpdateDate = dateToSqlFormat(parseDateFromString(analyzeData.date_start));
                analyzes.splice(tempAnalyzeIndex, 1);
                analyzes.push(analyzeData);

                analyzes = analyzes;

                identity.spy_balance -= 1;
                identity = identity;

                navigate(`${dashboardState.path}/dashboard/analyze/${response.data.id}`);
                return;
            } catch (err) { console.error(err); }
        } else {
            return response.data;
        }
    }

    async function updateAnalyzeProgress(id, progress = {}) {
        const analyzeIndex = analyzes.findIndex(item => item.id == id);
        if (analyzes[analyzeIndex]) {
            analyzes[analyzeIndex].progress = progress;
            analyzes[analyzeIndex].commentsProgress = progress.comments;
            analyzes[analyzeIndex].likesProgress = progress.likes;
            analyzes[analyzeIndex].storiesProgress = progress.stories;
            analyzes[analyzeIndex].guestsProgress = progress.guestsProgress;
            analyzes[analyzeIndex].unfollowsProgress = progress.unfollowsProgress;
            analyzes[analyzeIndex].deletedProgress = progress.deletedProgress;
            analyzes[analyzeIndex].fansProgress = progress.fansProgress;
            analyzes[analyzeIndex].postsProgress = progress.postsProgress;
            analyzes[analyzeIndex].listProgress = progress.list;
            analyzes[analyzeIndex].status = progress.analyze_status;
            analyzes[analyzeIndex].feedsUpdateIsFinished = progress.feedsUpdateIsFinished;
            analyzes[analyzeIndex].needRestart = progress.needRestart;
            analyzes[analyzeIndex].available_dates = progress.available_dates;

            analyzes = analyzes;
        }
    }

    async function updateResult(id, date) {
        const response = await updateAnalyzeResult(id, date);
        if (response.status === 'ok') {
            const analyzeIndex = analyzes.findIndex(item => item.id == id);
            if (analyzes[analyzeIndex]) {
                analyzes[analyzeIndex].result = response.result;
                analyzes[analyzeIndex].events = response.events;

                analyzes = analyzes;
            }
        }
    }


    let currentAnalyzeView = 'home';

    let currentRoute;
    function setCurrentRoute(route) {
        currentRoute = route;
        return '';
    }
    let currentAnalyze;
    function setAnalyzeByRoute(route) {
        if (!route || !route.id) return;

        const index = analyzes.findIndex(item => item.id == route.id);
        currentAnalyze = analyzes[index];
    }

    function getPaymentAgent() {
        if (language === 'en-US') {
            return 'stripe';
        }

        return 'yandex-kassa';
    }

    $: (currentRoute) && setAnalyzeByRoute(currentRoute);
</script>

<div class="app-wrap" >
    <Router url={currentUrl} basepath={path} >
        <DefaultLayout params={dashboardState} bind:identity={identity} totalAnalyzes={analyzes.length} {language}>
            <section slot="content" class="canvas">
                <Route path="/dashboard"><Home bind:analyzes={analyzes} bind:params={dashboardState} /></Route>
                <Route path="/signup"><Signup bind:params={dashboardState} /></Route>
                <Route path="/login"><Login bind:params={dashboardState} /></Route>
                <Route path="/dashboard/notification-settings">
                    <NotificationSettings bind:params={dashboardState} bind:identity={identity} locale={language} />
                </Route>
                <Route path="/dashboard/settings">
                    <Settings bind:params={dashboardState} bind:analyzes={analyzes} identity={identityWithFunctions} />
                </Route>
                <Route path="/dashboard/add-account">
                    <AddAccount bind:analyzes={analyzes}
                                bind:params={dashboardState}
                                totalAnalyzes={startedAnalyzes}
                    />
                </Route>
                <Route path="/dashboard/tutorial">
                    <Tutorial bind:params={dashboardState} {language} />
                </Route>
                <Route path="/dashboard/order/:id" let:params>
                    <Order bind:params={dashboardState} orderId={params.id} paymentAgent={getPaymentAgent()} locale={language} />
                </Route>
                <Route path="/dashboard/order-success">
                    <OrderSuccess bind:params={dashboardState} bind:identity={identity} {analyzes} locale={language} />
                </Route>
                <Route path="/dashboard/subscription">
                    <Subscription bind:params={dashboardState}
                                  availableTariffs={availableTariffs}
                                  totalAnalyzes={startedAnalyzes}
                                  bind:identity={identity}
                                  {unsubscribeDiscountValue}
                                  {unsubscribeDiscountedPrice}
                                  {analyzes}
                                  locale={language}
                    /></Route>
                <Route path="/dashboard/analyze/:id" let:params>
                    {setCurrentRoute(params)}
                    <Analyze bind:params={dashboardState}
                                 {availableTariffs}
                                 analyze={getAnalyze(params.id)}
                                 nextId={getNextId(params.id)}
                                 prevId={getPrevId(params.id)}
                                 totalAnalyzes={analyzes.length}
                                 {language}
                                 bind:date
                    />
                </Route>

            </section>
        </DefaultLayout>
    </Router>
</div>


<style>

</style>